<template>
  <Head :title="__('vip-order-who-are-you.meta.title')">
    <meta
      name="description"
      :content="__('vip-order-who-are-you.meta.description')"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.vips.order.who-are-you', [vip, shoutOut])"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <Order
    :vip="vip"
    :current-step="2"
  >
    <template #step>
      <form @submit.prevent="submit">
        <div class="w-full grid grid-cols-1 gap-4 md:gap-6 mt-4 lg:mt-8 lg:grid-cols-2">
          <div class="">
            <InputField
              v-model="form.name"
              :form="form"
              classes="border"
              name="name"
              type="text"
              :label="__('vip-order-who-are-you.form.name.text')"
              :placeholder="__('vip-order-who-are-you.form.name.placeholder')"
              maxlength="255"
            />
          </div>

          <div class="">
            <InputField
              v-model="form.email"
              :form="form"
              classes="border"
              name="email"
              type="email"
              :label="__('vip-order-who-are-you.form.email.text')"
              :placeholder="__('vip-order-who-are-you.form.email.placeholder')"
              maxlength="255"
            />
          </div>

          <div class="">
            <InputField
              v-model="form.phone"
              :form="form"
              classes="border"
              name="phone"
              type="tel"
              :label="__('vip-order-who-are-you.form.phone.text')"
              :placeholder="__('vip-order-who-are-you.form.phone.placeholder')"
              :is-required="false"
              maxlength="255"
            >
              <template #label>
                <i18n-t
                  keypath="vip-order-who-are-you.form.phone.extra.text"
                  scope="global"
                >
                  <template #extra>
                    <span class="font-normal text-xs">{{ __('vip-order-who-are-you.form.phone.extra.subtext') }}</span>
                  </template>
                </i18n-t>
              </template>
            </InputField>
          </div>

          <div class="">
            <InputField
              v-model="form.how_do_you_know"
              :form="form"
              classes="border"
              name="how_do_you_know"
              type="text"
              :label="__('vip-order-who-are-you.form.how-do-you-know.text')"
              :placeholder="__('vip-order-who-are-you.form.how-do-you-know.placeholder')"
              :is-required="false"
              maxlength="255"
            />
          </div>
        </div>

        <div class="w-full mt-6">
          <div class="relative flex items-start">
            <div class="flex items-center h-6">
              <input
                id="terms"
                v-model="form.conditions"
                type="checkbox"
                class="focus:ring-red h-4 w-4 text-red border-gray-200 rounded"
                name="terms"
                required
              >
            </div>
            <div class="ml-2">
              <label
                for="terms"
                class=" text-xs"
              >
                <i18n-t
                  keypath="vip-order-who-are-you.form.terms"
                  scope="global"
                >
                  <template #link>
                    <a
                      :href="localeRoute('frontend.terms-and-conditions')"
                      class="underline hover:no-underline"
                      target="_blank"
                    >
                      {{ __('vip-order-who-are-you.form.terms-link') }}
                    </a>
                  </template>
                </i18n-t>
              </label>
            </div>
          </div>

          <div class="relative flex items-start lg:mt-1">
            <div class="flex items-center h-6">
              <input
                id="share_video"
                v-model="form.do_not_share_video"
                type="checkbox"
                class="focus:ring-red h-4 w-4 text-red border-gray-200 rounded"
              >
            </div>
            <div class="ml-2">
              <label
                for="share_video"
                class="text-xs"
              >
                {{ __('vip-order-who-are-you.form.make-private-video') }}
              </label>
            </div>
          </div>

          <div class="mt-12 lg:mt-8 w-full lg:text-center">
            <button
              type="submit"
              class="button-green shadow-button-black w-full block lg:w-auto lg:inline-block lg:px-16"
            >
              {{ __('vip-order-who-are-you.continue') }}
              <img
                src="/frontend/assets/white-arrow.svg"
                class="inline ml-2"
              >
            </button>

            <Link
              :href="localeRoute('frontend.vips.order.for-who', [vip, shoutOut])"
              class="text-gray-500 font-bold mt-4 block text-center"
            >
              {{ __('vip-order-who-are-you.back') }}
            </Link>
          </div>
        </div>
      </form>
    </template>
  </Order>
</template>

<script>
import { reactive } from 'vue';
import Clean from '../../../Layout/Clean.vue';
import Order from './Order.vue';
import InputField from '../../../Components/Form/InputField.vue';

export default {
  components: {
    Order,
    InputField,
  },

  layout: Clean,

  props: {
    vip: {
      type: Object,
      required: true,
    },

    shoutOut: {
      type: Object,
      required: true,
    },

    customer: {
      type: Object,
      required: true,
    },
  },

  setup (props) {
    const form = reactive({
      name: props?.customer?.name || '',
      email: props?.customer?.email || '',
      phone: props?.customer?.phone || '',
      how_do_you_know: props?.shoutOut?.how_do_you_know || '',
      conditions: false,
      do_not_share_video: (props?.shoutOut?.visibility || 'public') === 'private',
    });

    return {form};
  },

  methods: {
    submit() {
      this.$inertia.post(this.localeRoute('frontend.vips.order.who-are-you.store', [this.vip, this.shoutOut.uuid]), this.form);
    },
  },
};
</script>
